// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accentWrapper":"_1zwoXf","articleLink":"dCybg6"};